
export class DevolucionUtil {
	static getBadgeClass(idEstado: number): string {
		switch (idEstado) {
			case 1:
				return 'badge-warning';
			case 2:
				return 'badge-info';
			case 3:
				return 'badge-success';
			case 4:
				return 'badge-danger';
			default:
				return 'badge-secondary';
		}
	}
}